import { defineStore } from 'pinia'
import type { ToastMsg } from '@/types/global'
import { DEFAULT_TOAST_LIFE } from '@/constants/toast'
import { ref } from 'vue'
import type { ToastMessageOptions } from 'primevue/toast'
import { useTranslation } from 'i18next-vue'

export const useToastStore = defineStore('toast', () => {
    const toastMessage = ref<ToastMessageOptions | null>(null)
    const shownVersion = ref<string | null>(null)
    const pendingVersion = ref<string | null>(null)
    const { t } = useTranslation()

    function showNewVersionToastOnce(version: string) {
        if (shownVersion.value === version || pendingVersion.value === version) return

        pendingVersion.value = version
        toastMessage.value = {
            severity: 'info',
            summary: t('ui.newVersion.message'),
            life: 10000,
            group: 'refresh',
        }
    }

    function markVersionToastShown() {
        if (pendingVersion.value) {
            shownVersion.value = pendingVersion.value
            pendingVersion.value = null
        }
    }

    function showToast(toast: ToastMsg) {
        toastMessage.value = {
            life: DEFAULT_TOAST_LIFE,
            ...toast,
        }
    }

    function clearToast() {
        toastMessage.value = null
        pendingVersion.value = null
    }

    return {
        toastMessage,
        shownVersion,
        showToast,
        showNewVersionToastOnce,
        markVersionToastShown,
        clearToast,
    }
})
